<!--  -->
<template>
<div class='' v-show="show" style="height:90%">
<el-button style="margin-bottom:10px" @click="addShowData()" type="success" icon="el-icon-plus" plain>添加数据</el-button>
 <el-table
      :data="tableData.list"
      style="width: 100%;height:85%;overflow: scroll;">
      <el-table-column
        label="背景图"
        width="180">
        <template slot-scope="scope">
          <el-image style="width: 150px; height: 100px" :src="scope.row.backImg" fit="scale-down"></el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="ifshow"
        label="是否展示"
        :filters="[{text:'展示',value:true},{text:'未展示',value:false}]"
        width="180">
        <template slot-scope="scope">
            <el-switch
            :value="scope.row.ifshow"
            @change="changeDisplay(scope.$index,scope.row)"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="发布时间"
        sortable
        width="180">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="margin-right:10px"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-popconfirm
            confirm-button-text='确定'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="handleDelete(scope.$index, scope.row)"
            title="确定删除吗？">
            <el-button
            size="mini"
            type="danger"
            slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="margin-top:10px"
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="tableData.totalCount"
      :page-size="tableData.pageSize">
    </el-pagination>
    <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="40%" append-to-body>
      <el-form ref="showForm" :rules="checkShowData" :model="form">
        <el-form-item style="display:none">
          <el-input v-model="form.id" clearable></el-input>
        </el-form-item>
        <el-form-item label="展示图片" label-width="120px" prop="backImg">
          <s-upload-img :getImageUrl="getBackImg" :url="form.backImg"></s-upload-img>
        </el-form-item>
        <el-form-item label="是否展示" label-width="120px">
          <el-switch
            v-model="form.ifshow"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitShowData('showForm')">确 定</el-button>
      </div>
    </el-dialog>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import sUploadImg from '@/components/SingleImgUpload'
import {query,insert,update,queryList,deleted} from '@/api/admin/companyShow.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {sUploadImg},
data() {
//这里存放数据
return {
 show:false,
 dialogFormVisible:false,
 condition:{
    current:1,
    size:5,
    title:""
  },
 tableData:[
  {
    backImg:"",
    display:false,
    date:""
  }
 ],
 form:{
   id:"",
   ifshow:false,
   backImg:""
 },
 checkShowData:{
  backImg:{required:true,message:"请上传图片",trigger:'blur'}
 }
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  handleCurrentChange(val){
    var _this =this
    _this.condition.current = val
    queryList(_this.condition).then(({data})=>{
      _this.tableData=data
    })
  },
  submitShowData(name){
    var _this = this
    this.$refs[name].validate((valid)=>{
      if(valid){
        if(this.form.id==""||this.form.id==undefined||this.form.id==null){
           insert(_this.form).then(()=>{
              this.$message.success("添加成功")
              _this.dialogFormVisible=false
              queryList(_this.condition).then(({data})=>{
                if(data!=null){
                _this.tableData = data
                }
             })
           })
        }else{
           update(_this.form).then(()=>{
            this.$message.success("修改成功")
              queryList(_this.condition).then(({data})=>{
                if(data!=null){
                _this.tableData = data
                }
              })
           })
        }
      }else{
        this.$message.info("请根据错误提示填写完整信息")
      }
    })
  },
  addShowData(){
   this.dialogFormVisible=true
   this.form={id:"",ifshow:false,backImg:""}
  },
  getBackImg(val){
    this.form.backImg = val
  },
 handleEdit(index, row){
    var _this = this
    this.dialogFormVisible=true
    query({id:row.id}).then(({data})=>{
      _this.form = data
    })
  },
  changeDisplay(index,row){
    var _this = this
    update({id:row.id,ifshow:!row.ifshow}).then(()=>{
      _this.$message.success("更新成功!")
    })
    this.tableData.list[index].ifshow=!this.tableData.list[index].ifshow
 },
 handleDelete(index){
    var _this = this
    deleted(_this.tableData.list[index]).then(()=>{
      if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
        _this.condition.current=_this.condition.current-1
      }
      _this.$message.success("删除成功!")
      queryList(_this.condition).then(({data})=>{
        _this.tableData=data
      },()=>{_this.tableData.list=[]})
    })
 }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 var _this = this
 queryList(_this.condition).then(({data})=>{
      if(data!=null){
      _this.tableData = data
      }
  })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类

</style>